import { NavLink } from 'react-router-dom';

export default function AdminSidebar() {

    return (
        <aside className="admin-sidebar">

            <nav className="sidebar-nav">

                <NavLink
                    to="/admin-dashboard"
                    className="sidebar-link"
                >
                    Dashboard
                </NavLink>

                <NavLink
                    to="/admin-users"
                    className="sidebar-link"
                >
                    Users
                </NavLink>
                <NavLink
                    to="/admin-home-page"
                    className="sidebar-link"
                >
                    Home Page
                </NavLink>
                <NavLink
                    to="/admin-best-served-with"
                    className="sidebar-link"
                >
                    Best Served With
                </NavLink>
                <NavLink
                    to="/admin-ranges"
                    className="sidebar-link"
                >
                    Our Range
                </NavLink>
                <NavLink to="/admin-lets-cook" className="sidebar-link">
                    Let's Cook Headers
                </NavLink>
                <NavLink
                    to="/admin-cuisines"
                    className="sidebar-link"
                >
                    Recipe Cuisines
                </NavLink>
                {/*<NavLink*/}
                {/*    to="/admin-recipe-categories"*/}
                {/*    className="sidebar-link"*/}
                {/*>*/}
                {/*    Recipe Categories*/}
                {/*</NavLink>*/}
                <NavLink
                    to="/admin-difficulty"
                    className="sidebar-link"
                >
                    Recipe Difficulties
                </NavLink>
                <NavLink
                    to="/admin-occasions"
                    className="sidebar-link"
                >
                    Recipe Occasions
                </NavLink>
                <NavLink
                    to="/admin-proteins"
                    className="sidebar-link"
                >
                    Recipe Proteins
                </NavLink>
                <NavLink
                    to="/admin-times"
                    className="sidebar-link"
                >
                    Recipe Time
                </NavLink>
                <NavLink
                    to="/admin-dietary-preferences"
                    className="sidebar-link"
                >
                    Recipe Dietary Preferences
                </NavLink>
                <NavLink
                    to="/admin-cooking-methods"
                    className="sidebar-link"
                >
                    Recipe Cooking Method
                </NavLink>
                <NavLink
                    to="/admin-recipes"
                    className="sidebar-link"
                >
                    Recipes
                </NavLink>
                <NavLink
                    to="/admin-fan-recipes"
                    className="sidebar-link"
                >
                    Fan Recipes
                </NavLink>
                <NavLink
                    to="/admin-blog-categories"
                    className="sidebar-link"
                >
                    Blog Categories
                </NavLink>
                <NavLink
                    to="/admin-blogs"
                    className="sidebar-link"
                >
                    Blogs
                </NavLink>
                <NavLink
                    to="/admin-testimonials"
                    className="sidebar-link"
                >
                    Testimonials
                </NavLink>
                <NavLink
                    to="/admin-about-us"
                    className="sidebar-link"
                >
                    About Us
                </NavLink>
                <NavLink
                    to="/admin-contact-us"
                    className="sidebar-link"
                >
                    Contact Us
                </NavLink>
                <NavLink to={"/admin-where-to-buy"} className={"sidebar-link"}>
                    Where To Buy
                </NavLink>



                {/*<NavLink*/}
                {/*    to="/admin-products"*/}
                {/*    className="sidebar-link"*/}
                {/*>*/}
                {/*    Products*/}
                {/*</NavLink>*/}

                {/*<NavLink*/}
                {/*    to="/admin-enquiries"*/}
                {/*    className="sidebar-link"*/}
                {/*>*/}
                {/*    Enquiries*/}
                {/*</NavLink>*/}

                {/*<NavLink*/}
                {/*    to="/admin-settings"*/}
                {/*    className="sidebar-link"*/}
                {/*>*/}
                {/*    Settings*/}
                {/*</NavLink>*/}

            </nav>

        </aside>
    );
}
